import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import configuration from 'config';

const CanonicalUrl = (): JSX.Element => {
  const { pathname } = useLocation<{ pathname: string }>();

  useEffect(() => {
    // Remove existing canonical link if it exists
    const existingCanonical = document.querySelector('link[rel="canonical"]');
    if (existingCanonical) {
      existingCanonical.remove();
    }

    // Create new canonical link
    const canonicalLink = document.createElement('link');
    canonicalLink.rel = 'canonical';

    // Build the full canonical URL
    const baseUrl = configuration.canonicalUrl;

    // Use customPath if provided, otherwise use current location pathname, or fallback to path prop
    const currentPath = pathname;

    // Clean and validate the URL
    const cleanBaseUrl = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
    const cleanPath = currentPath.startsWith('/') ? currentPath : `/${currentPath}`;
    const fullUrl = `${cleanBaseUrl}${cleanPath}`;

    // Validate URL format
    try {
      const url = new URL(fullUrl);
      canonicalLink.href = url.href;
    } catch (error) {
      // Fallback to base URL if invalid
      canonicalLink.href = cleanBaseUrl;
    }

    // Add to head
    document.head.appendChild(canonicalLink);
  }, [pathname]);

  return <></>;
};

export default CanonicalUrl;
